(function(){
"use strict";

// ---------------------------------------------------------------
// State
// ---------------------------------------------------------------
const NUM_BLOBS = 6;

function defaultState(){
  return {
    bg: "#040611",
    colors: ["#1e6fe0", "#050914", "#0a2f8f", "#02041d", "#174bcb", "#000000"],
    fluteWidth: 18,
    fluteStrength: 160,
    shading: 8,
    glossiness: 0.70,
    lightAngle: -1.0,
    gradientScale: 1.10,
    sharpness: 8.0,
    intensity: 0.55,
    exposure: 2.05,
    warpStrength: 0.42,
    noiseX: 0.9,
    noiseY: 0.6,
    animSpeed: 0.45,
    grain: 0.015,
    blobs: null // filled by randomizeBlobs() or defaultBlobs()
  };
}

// A fixed (non-random) blob layout so the tool always opens looking the
// same way, rather than a fresh random composition on every load.
function defaultBlobs(){
  return [
    { baseX:-0.30, baseY: 0.08, ampX:0.12, ampY:0.10, freqX:0.31, freqY:0.27, phase:0.6 },
    { baseX: 0.28, baseY: 0.22, ampX:0.14, ampY:0.11, freqX:0.24, freqY:0.36, phase:2.1 },
    { baseX:-0.08, baseY:-0.28, ampX:0.10, ampY:0.15, freqX:0.42, freqY:0.22, phase:4.0 },
    { baseX: 0.36, baseY:-0.12, ampX:0.13, ampY:0.09, freqX:0.28, freqY:0.5,  phase:1.2 },
    { baseX:-0.38, baseY:-0.18, ampX:0.09, ampY:0.13, freqX:0.5,  freqY:0.31, phase:3.4 },
    { baseX: 0.06, baseY: 0.34, ampX:0.11, ampY:0.12, freqX:0.35, freqY:0.44, phase:5.2 }
  ];
}

const PALETTES = [
  { name:"30MS Blue", bg:"#040611", colors:["#1e6fe0","#050914","#0a2f8f","#02041d","#174bcb","#000000"] },
  { name:"Reeded Blue", bg:"#040611", colors:["#1e6fe0","#3fb6ff","#0a2f8f","#7fd8ff","#123a9c","#2b8fe6"] },
  { name:"Blue v2", bg:"#040611", colors:["#1a60c1","#050914","#4a8fcc","#050d43","#1951dc","#1952dc"] }
];

function hexToRgb01(hex){
  const h = hex.replace('#','');
  const r = parseInt(h.substring(0,2),16)/255;
  const g = parseInt(h.substring(2,4),16)/255;
  const b = parseInt(h.substring(4,6),16)/255;
  return [r,g,b];
}
function clamp01(v){ return Math.max(0, Math.min(1, v)); }
function rgbToHex(r,g,b){
  const c = v => Math.round(clamp01(v)*255).toString(16).padStart(2,'0');
  return '#'+c(r)+c(g)+c(b);
}
function isValidHex(h){ return /^#?[0-9a-fA-F]{6}$/.test(h); }
function normHex(h){ h = h.trim(); if(h[0] !== '#') h = '#'+h; return h.toLowerCase(); }

let state = defaultState();

function randomizeBlobs(){
  const blobs = [];
  for(let i=0;i<NUM_BLOBS;i++){
    blobs.push({
      baseX: (Math.random()*2-1) * 0.42,
      baseY: (Math.random()*2-1) * 0.32,
      ampX: 0.08 + Math.random()*0.16,
      ampY: 0.06 + Math.random()*0.14,
      freqX: 0.2 + Math.random()*0.55,
      freqY: 0.2 + Math.random()*0.55,
      phase: Math.random()*Math.PI*2
    });
  }
  state.blobs = blobs;
}
state.blobs = defaultBlobs();

// ---------------------------------------------------------------
// WebGL setup
// ---------------------------------------------------------------
const canvas = document.getElementById('glcanvas');
const gl = canvas.getContext('webgl', {preserveDrawingBuffer:true, antialias:true}) ||
           canvas.getContext('experimental-webgl', {preserveDrawingBuffer:true});

if(!gl){
  document.getElementById('canvasWrap').innerHTML =
    '<div style="color:#fff;padding:40px;font-family:sans-serif;">WebGL is not available in this browser/environment.</div>';
  throw new Error("No WebGL");
}

const VERT_SRC = `
attribute vec2 aPos;
void main(){
  gl_Position = vec4(aPos, 0.0, 1.0);
}
`;

const NOISE_SNOISE = `
vec3 mod289_3(vec3 x){ return x - floor(x * (1.0/289.0)) * 289.0; }
vec2 mod289_2(vec2 x){ return x - floor(x * (1.0/289.0)) * 289.0; }
vec3 permute3(vec3 x){ return mod289_3(((x*34.0)+1.0)*x); }
float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439, -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy));
  vec2 x0 = v - i + dot(i, C.xx);
  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod289_2(i);
  vec3 p = permute3( permute3( i.y + vec3(0.0, i1.y, 1.0)) + i.x + vec3(0.0, i1.x, 1.0));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
  m = m*m; m = m*m;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * (a0*a0 + h*h);
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}
`;

const NOISE_FRAG_SRC = `
precision highp float;
uniform vec2 uNoiseRes;
uniform float uTime;
uniform float uAnimSpeed;
uniform vec2 uNoiseScale;
${NOISE_SNOISE}
void main(){
  vec2 uv = gl_FragCoord.xy / uNoiseRes;
  // 0.16 is the calibrated base evolution rate; uAnimSpeed is a simple,
  // intuitive playback multiplier on top of it (1.00x = original pace).
  float t = uTime * uAnimSpeed * 0.16;
  float nx = snoise(uv * uNoiseScale + t * 0.5);
  float ny = snoise(uv * uNoiseScale * 0.93 - t * 0.3);
  gl_FragColor = vec4(nx*0.5+0.5, ny*0.5+0.5, 0.0, 1.0);
}
`;

const MAIN_FRAG_SRC = `
precision highp float;

uniform vec2 uResolution;
uniform float uTime;
uniform float uAnimSpeed;
uniform float uFluteWidth;
uniform float uFluteStrength;
uniform float uShading;
uniform float uGlossiness;
uniform float uLightAngle;
uniform float uGradientScale;
uniform float uToneMapExposure;
uniform float uGrainStrength;
uniform float uBlobSharpness;
uniform float uBlobIntensity;
uniform vec3 uBgColor;
uniform vec3 uColors[6];
uniform vec2 uBlobBase[6];
uniform vec2 uBlobAmp[6];
uniform vec3 uBlobFreqPhase[6];
uniform sampler2D uNoiseMap;
uniform float uWarpStrength;

float hash(vec2 p){
  return fract(sin(dot(p, vec2(127.1,311.7))) * 43758.5453123);
}

void main(){
  // Normalize against a fixed reference height so the framing/zoom of the
  // pattern is identical between the live preview and any export size —
  // only pixel density changes, never the composition.
  float pixelScale = 1080.0 / uResolution.y;
  vec2 mappedCoords = (gl_FragCoord.xy - uResolution * 0.5) * pixelScale;

  vec2 scaledUv = mappedCoords / vec2(uFluteWidth);
  vec2 fractUv = vec2(fract(scaledUv.x), scaledUv.y);
  float flutedX = uFluteStrength * (fractUv.x - 0.5);
  float flutedY = sin(fractUv.x * 3.14159265) * uFluteStrength * 0.12;
  vec2 flutedCoords = vec2(mappedCoords.x + flutedX, mappedCoords.y + flutedY);

  // Zoom: higher uGradientScale = more zoomed in (bigger, softer blobs).
  vec2 uv = flutedCoords / (1000.0 * uGradientScale);

  vec2 noiseUv = gl_FragCoord.xy / uResolution;
  vec2 warpNoise = texture2D(uNoiseMap, noiseUv).rg * 2.0 - 1.0;
  vec2 warpedUv = uv + warpNoise * uWarpStrength;

  float animT = uTime * uAnimSpeed;

  vec3 color = uBgColor;
  for(int i=0;i<6;i++){
    vec2 p = uBlobBase[i] + vec2(
      sin(animT * uBlobFreqPhase[i].x + uBlobFreqPhase[i].z) * uBlobAmp[i].x,
      cos(animT * uBlobFreqPhase[i].y + uBlobFreqPhase[i].z * 1.3) * uBlobAmp[i].y
    );
    float d = dot(warpedUv - p, warpedUv - p);
    color += uColors[i] * exp(-d * uBlobSharpness) * uBlobIntensity;
  }

  color = 1.0 - exp(-color * uToneMapExposure);

  // --- Reeded / fluted glass shading with a glossy specular streak ---
  float fx = fractUv.x;
  // Cylindrical "normal" x-component across each rod/flute, -1..1
  float nx = sin((fx - 0.5) * 3.14159265);

  // Soft ambient light/dark falloff across the rod
  float ambient = 0.72 + 0.34 * (1.0 - abs(nx));

  // Tight glossy highlight streak (position adjustable = light angle)
  float spec = pow(clamp(1.0 - abs(nx - uLightAngle) * 1.6, 0.0, 1.0), 10.0);
  float specular = spec * uGlossiness;

  // Dark seam shadow right at the boundary between adjacent flutes
  float seamMask = smoothstep(0.0, 0.05, fx) * smoothstep(1.0, 0.95, fx);
  float seam = mix(0.5, 1.0, seamMask);

  float reeded = ambient * seam + specular;
  float shade = mix(1.0, reeded, uShading);
  color *= shade;

  float grain = hash(gl_FragCoord.xy + fract(uTime) * 1000.0) * 2.0 - 1.0;
  color += grain * uGrainStrength * max(color.r, max(color.g, color.b));

  color = clamp(color, 0.0, 1.0);
  gl_FragColor = vec4(color, 1.0);
}
`;

function compileShader(src, type){
  const sh = gl.createShader(type);
  gl.shaderSource(sh, src);
  gl.compileShader(sh);
  if(!gl.getShaderParameter(sh, gl.COMPILE_STATUS)){
    console.error(gl.getShaderInfoLog(sh));
    throw new Error("Shader compile error: " + gl.getShaderInfoLog(sh));
  }
  return sh;
}
function linkProgram(vsSrc, fsSrc){
  const vs = compileShader(vsSrc, gl.VERTEX_SHADER);
  const fs = compileShader(fsSrc, gl.FRAGMENT_SHADER);
  const prog = gl.createProgram();
  gl.attachShader(prog, vs);
  gl.attachShader(prog, fs);
  gl.linkProgram(prog);
  if(!gl.getProgramParameter(prog, gl.LINK_STATUS)){
    console.error(gl.getProgramInfoLog(prog));
    throw new Error("Program link error: " + gl.getProgramInfoLog(prog));
  }
  return prog;
}

const noiseProgram = linkProgram(VERT_SRC, NOISE_FRAG_SRC);
const mainProgram = linkProgram(VERT_SRC, MAIN_FRAG_SRC);

// Fullscreen quad (two triangles)
const quadBuf = gl.createBuffer();
gl.bindBuffer(gl.ARRAY_BUFFER, quadBuf);
gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
  -1,-1,  1,-1,  -1,1,
  -1,1,   1,-1,   1,1
]), gl.STATIC_DRAW);

function bindQuad(program){
  const loc = gl.getAttribLocation(program, 'aPos');
  gl.bindBuffer(gl.ARRAY_BUFFER, quadBuf);
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
}

// Noise render target
const NOISE_RES = 512;
const noiseTex = gl.createTexture();
gl.bindTexture(gl.TEXTURE_2D, noiseTex);
gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, NOISE_RES, NOISE_RES, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);

const noiseFbo = gl.createFramebuffer();
gl.bindFramebuffer(gl.FRAMEBUFFER, noiseFbo);
gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, noiseTex, 0);
gl.bindFramebuffer(gl.FRAMEBUFFER, null);

// Uniform locations
const noiseU = {
  uNoiseRes: gl.getUniformLocation(noiseProgram, 'uNoiseRes'),
  uTime: gl.getUniformLocation(noiseProgram, 'uTime'),
  uAnimSpeed: gl.getUniformLocation(noiseProgram, 'uAnimSpeed'),
  uNoiseScale: gl.getUniformLocation(noiseProgram, 'uNoiseScale'),
};
const mainU = {
  uResolution: gl.getUniformLocation(mainProgram, 'uResolution'),
  uTime: gl.getUniformLocation(mainProgram, 'uTime'),
  uAnimSpeed: gl.getUniformLocation(mainProgram, 'uAnimSpeed'),
  uFluteWidth: gl.getUniformLocation(mainProgram, 'uFluteWidth'),
  uFluteStrength: gl.getUniformLocation(mainProgram, 'uFluteStrength'),
  uShading: gl.getUniformLocation(mainProgram, 'uShading'),
  uGlossiness: gl.getUniformLocation(mainProgram, 'uGlossiness'),
  uLightAngle: gl.getUniformLocation(mainProgram, 'uLightAngle'),
  uGradientScale: gl.getUniformLocation(mainProgram, 'uGradientScale'),
  uToneMapExposure: gl.getUniformLocation(mainProgram, 'uToneMapExposure'),
  uGrainStrength: gl.getUniformLocation(mainProgram, 'uGrainStrength'),
  uBlobSharpness: gl.getUniformLocation(mainProgram, 'uBlobSharpness'),
  uBlobIntensity: gl.getUniformLocation(mainProgram, 'uBlobIntensity'),
  uBgColor: gl.getUniformLocation(mainProgram, 'uBgColor'),
  uColors: gl.getUniformLocation(mainProgram, 'uColors'),
  uBlobBase: gl.getUniformLocation(mainProgram, 'uBlobBase'),
  uBlobAmp: gl.getUniformLocation(mainProgram, 'uBlobAmp'),
  uBlobFreqPhase: gl.getUniformLocation(mainProgram, 'uBlobFreqPhase'),
  uNoiseMap: gl.getUniformLocation(mainProgram, 'uNoiseMap'),
  uWarpStrength: gl.getUniformLocation(mainProgram, 'uWarpStrength'),
};

function renderNoisePass(timeSec){
  gl.bindFramebuffer(gl.FRAMEBUFFER, noiseFbo);
  gl.viewport(0,0,NOISE_RES,NOISE_RES);
  gl.useProgram(noiseProgram);
  bindQuad(noiseProgram);
  gl.uniform2f(noiseU.uNoiseRes, NOISE_RES, NOISE_RES);
  gl.uniform1f(noiseU.uTime, timeSec);
  gl.uniform1f(noiseU.uAnimSpeed, state.animSpeed);
  gl.uniform2f(noiseU.uNoiseScale, state.noiseX, state.noiseY);
  gl.drawArrays(gl.TRIANGLES, 0, 6);
  gl.bindFramebuffer(gl.FRAMEBUFFER, null);
}

function renderMainPass(timeSec, width, height){
  gl.viewport(0,0,width,height);
  gl.useProgram(mainProgram);
  bindQuad(mainProgram);

  gl.uniform2f(mainU.uResolution, width, height);
  gl.uniform1f(mainU.uTime, timeSec);
  gl.uniform1f(mainU.uAnimSpeed, state.animSpeed);
  gl.uniform1f(mainU.uFluteWidth, state.fluteWidth);
  gl.uniform1f(mainU.uFluteStrength, state.fluteStrength);
  gl.uniform1f(mainU.uShading, state.shading/100);
  gl.uniform1f(mainU.uGlossiness, state.glossiness);
  gl.uniform1f(mainU.uLightAngle, state.lightAngle);
  gl.uniform1f(mainU.uGradientScale, state.gradientScale);
  gl.uniform1f(mainU.uToneMapExposure, state.exposure);
  gl.uniform1f(mainU.uGrainStrength, state.grain);
  gl.uniform1f(mainU.uBlobSharpness, state.sharpness);
  gl.uniform1f(mainU.uBlobIntensity, state.intensity);
  gl.uniform1f(mainU.uWarpStrength, state.warpStrength);

  const bg = hexToRgb01(state.bg);
  gl.uniform3f(mainU.uBgColor, bg[0], bg[1], bg[2]);

  const colorsFlat = new Float32Array(NUM_BLOBS*3);
  const baseFlat = new Float32Array(NUM_BLOBS*2);
  const ampFlat = new Float32Array(NUM_BLOBS*2);
  const fpFlat = new Float32Array(NUM_BLOBS*3);
  for(let i=0;i<NUM_BLOBS;i++){
    const c = hexToRgb01(state.colors[i]);
    colorsFlat[i*3+0]=c[0]; colorsFlat[i*3+1]=c[1]; colorsFlat[i*3+2]=c[2];
    const b = state.blobs[i];
    baseFlat[i*2+0]=b.baseX; baseFlat[i*2+1]=b.baseY;
    ampFlat[i*2+0]=b.ampX; ampFlat[i*2+1]=b.ampY;
    fpFlat[i*3+0]=b.freqX; fpFlat[i*3+1]=b.freqY; fpFlat[i*3+2]=b.phase;
  }
  gl.uniform3fv(mainU.uColors, colorsFlat);
  gl.uniform2fv(mainU.uBlobBase, baseFlat);
  gl.uniform2fv(mainU.uBlobAmp, ampFlat);
  gl.uniform3fv(mainU.uBlobFreqPhase, fpFlat);

  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, noiseTex);
  gl.uniform1i(mainU.uNoiseMap, 0);

  gl.drawArrays(gl.TRIANGLES, 0, 6);
}

// ---------------------------------------------------------------
// Animation loop
// ---------------------------------------------------------------
let playing = false;
let clockStart = performance.now();
let pausedAt = 1300;

function currentTimeSec(){
  if(playing){
    return (performance.now() - clockStart) / 1000;
  }
  return pausedAt;
}

function resizeCanvas(){
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const w = Math.round(canvas.clientWidth * dpr);
  const h = Math.round(canvas.clientHeight * dpr);
  if(canvas.width !== w || canvas.height !== h){
    canvas.width = w;
    canvas.height = h;
  }
}

let exporting = false;
let lastT = 0;
function frame(){
  if(!exporting){
    resizeCanvas();
    const t = currentTimeSec();
    lastT = t;
    renderNoisePass(t);
    renderMainPass(t, canvas.width, canvas.height);
    const seedEl = document.getElementById('seedInput');
    if(seedEl && playing && document.activeElement !== seedEl){
      seedEl.value = t.toFixed(2);
    }
  }
  requestAnimationFrame(frame);
}
requestAnimationFrame(frame);

// ---------------------------------------------------------------
// UI wiring
// ---------------------------------------------------------------
const colorNames = ["Blob 1","Blob 2","Blob 3","Blob 4","Blob 5","Blob 6"];

// function buildColorList(){
//   const wrap = document.getElementById('colorList');
//   wrap.innerHTML = '';

//   // background row
//   wrap.appendChild(makeColorRow("Background", state.bg, (hex)=>{ state.bg = hex; }));

//   for(let i=0;i<NUM_BLOBS;i++){
//     wrap.appendChild(makeColorRow(colorNames[i], state.colors[i], (hex)=>{ state.colors[i] = hex; }));
//   }
// }

// function makeColorRow(label, initialHex, onChange){
//   const row = document.createElement('div');
//   row.className = 'colorrow';

//   const nameEl = document.createElement('div');
//   nameEl.className = 'cname';
//   nameEl.textContent = label;

//   const swatch = document.createElement('input');
//   swatch.type = 'color';
//   swatch.className = 'swatch-input';
//   swatch.value = initialHex;

//   const text = document.createElement('input');
//   text.type = 'text';
//   text.value = initialHex;
//   text.maxLength = 7;

//   swatch.addEventListener('input', ()=>{
//     text.value = swatch.value;
//     onChange(swatch.value);
//   });
//   text.addEventListener('change', ()=>{
//     const h = normHex(text.value);
//     if(isValidHex(h)){
//       text.value = h;
//       swatch.value = h;
//       onChange(h);
//     } else {
//       text.value = swatch.value;
//     }
//   });

//   row.appendChild(nameEl);
//   row.appendChild(swatch);
//   row.appendChild(text);
//   return row;
// }

// ---------------------------------------------------------------
// Custom saved palettes (persisted to localStorage where available)
// ---------------------------------------------------------------
// const CUSTOM_PALETTES_KEY = 'fgg_custom_palettes_v1';
// let customPalettes = [];
// function loadCustomPalettes(){
//   try{
//     const raw = localStorage.getItem(CUSTOM_PALETTES_KEY);
//     customPalettes = raw ? JSON.parse(raw) : [];
//   } catch(e){
//     customPalettes = [];
//   }
// }
// function saveCustomPalettesToStorage(){
//   try{
//     localStorage.setItem(CUSTOM_PALETTES_KEY, JSON.stringify(customPalettes));
//   } catch(e){
//     // storage unavailable in this context — palette still works for this session
//   }
// }
// loadCustomPalettes();

// function makePaletteCard(pal, onClick, onDelete){
//   const card = document.createElement('div');
//   card.className = 'palette-card';
//   card.style.position = 'relative';
//   const sw = document.createElement('div');
//   sw.className = 'swatches';
//   [pal.bg, ...pal.colors].forEach(hex=>{
//     const d = document.createElement('div');
//     d.style.background = hex;
//     sw.appendChild(d);
//   });
//   const label = document.createElement('div');
//   label.className = 'pname';
//   label.textContent = pal.name;
//   card.appendChild(sw);
//   card.appendChild(label);
//   card.addEventListener('click', onClick);
//   if(onDelete){
//     const del = document.createElement('button');
//     del.textContent = '×';
//     del.title = 'Delete palette';
//     del.style.cssText = 'position:absolute; top:4px; right:4px; width:18px; height:18px; line-height:16px; border-radius:50%; border:none; background:rgba(0,0,0,0.6); color:#fff; font-size:12px; cursor:pointer; padding:0;';
//     del.addEventListener('click', (e)=>{
//       e.stopPropagation();
//       onDelete();
//     });
//     card.appendChild(del);
//   }
//   return card;
// }

// function buildPalettes(){
//   const grid = document.getElementById('paletteGrid');
//   grid.innerHTML = '';
//   PALETTES.forEach(pal=>{
//     grid.appendChild(makePaletteCard(pal, ()=>{
//       state.bg = pal.bg;
//       state.colors = pal.colors.slice();
//       buildColorList();
//     }));
//   });
// }

// function buildMyPalettes(){
//   const wrap = document.getElementById('myPalettesWrap');
//   const grid = document.getElementById('myPaletteGrid');
//   grid.innerHTML = '';
//   if(customPalettes.length === 0){
//     wrap.style.display = 'none';
//     return;
//   }
//   wrap.style.display = 'block';
//   customPalettes.forEach((pal, idx)=>{
//     grid.appendChild(makePaletteCard(pal, ()=>{
//       state.bg = pal.bg;
//       state.colors = pal.colors.slice();
//       buildColorList();
//     }, ()=>{
//       if(confirm(`Delete palette "${pal.name}"?`)){
//         customPalettes.splice(idx,1);
//         saveCustomPalettesToStorage();
//         buildMyPalettes();
//       }
//     }));
//   });
// }

// function bindSlider(id, valId, stateKey, decimals, suffix){
//   const input = document.getElementById(id);
//   const valEl = document.getElementById(valId);
//   input.value = state[stateKey];
//   const fmt = v => (decimals === 0 ? Math.round(v) : Number(v).toFixed(decimals)) + (suffix||'');
//   valEl.textContent = fmt(state[stateKey]);
//   input.addEventListener('input', ()=>{
//     state[stateKey] = parseFloat(input.value);
//     valEl.textContent = fmt(state[stateKey]);
//   });
// }

// function initControls(){
//   buildColorList();
//   buildPalettes();
//   buildMyPalettes();

//   bindSlider('s_fluteWidth','v_fluteWidth','fluteWidth',0,'px');
//   bindSlider('s_fluteStrength','v_fluteStrength','fluteStrength',0,'px');
//   bindSlider('s_shading','v_shading','shading',0,'%');
//   bindSlider('s_glossiness','v_glossiness','glossiness',2,'');
//   bindSlider('s_lightAngle','v_lightAngle','lightAngle',2,'');
//   bindSlider('s_gradientScale','v_gradientScale','gradientScale',2,'×');
//   bindSlider('s_sharpness','v_sharpness','sharpness',1,'');
//   bindSlider('s_intensity','v_intensity','intensity',2,'');
//   bindSlider('s_exposure','v_exposure','exposure',2,'');
//   bindSlider('s_warpStrength','v_warpStrength','warpStrength',2,'');
//   bindSlider('s_noiseX','v_noiseX','noiseX',1,'');
//   bindSlider('s_noiseY','v_noiseY','noiseY',1,'');
//   bindSlider('s_animSpeed','v_animSpeed','animSpeed',2,'×');
//   bindSlider('s_grain','v_grain','grain',3,'');

//   document.getElementById('savePaletteBtn').addEventListener('click', ()=>{
//     const name = prompt('Name this palette:', `Custom ${customPalettes.length+1}`);
//     if(name === null) return; // cancelled
//     const trimmed = name.trim() || `Custom ${customPalettes.length+1}`;
//     customPalettes.push({ name: trimmed, bg: state.bg, colors: state.colors.slice() });
//     saveCustomPalettesToStorage();
//     buildMyPalettes();
//   });

//   document.getElementById('playBtn').addEventListener('click', ()=>{
//     if(playing){
//       // About to pause — capture the exact live frame first, before
//       // flipping `playing`, otherwise currentTimeSec() would already see
//       // playing=false and hand back the stale previous pausedAt instead.
//       pausedAt = (performance.now() - clockStart) / 1000;
//     }
//     playing = !playing;
//     if(playing){
//       clockStart = performance.now() - pausedAt*1000;
//     }
//     document.getElementById('playBtn').textContent = playing ? '⏸ Pause' : '▶ Play';
//     const seedEl = document.getElementById('seedInput');
//     seedEl.disabled = playing;
//     if(!playing) seedEl.value = pausedAt.toFixed(2);
//   });

//   const seedEl = document.getElementById('seedInput');
//   seedEl.value = pausedAt.toFixed(2);
//   seedEl.disabled = playing;
//   seedEl.addEventListener('change', ()=>{
//     const v = parseFloat(seedEl.value);
//     if(!isNaN(v)){
//       pausedAt = v;
//       if(!playing){
//         // nothing else to sync, currentTimeSec() already reads pausedAt
//       }
//     }
//   });

//   document.getElementById('randomBtn').addEventListener('click', ()=>{
//     randomizeBlobs();
//     const pal = PALETTES[Math.floor(Math.random()*PALETTES.length)];
//     state.bg = pal.bg;
//     state.colors = pal.colors.slice();
//     buildColorList();
//   });

//   document.getElementById('resetBtn').addEventListener('click', ()=>{
//     const wasPlaying = playing;
//     state = defaultState();
//     state.blobs = defaultBlobs();
//     buildColorList();
//     // re-sync sliders
//     document.getElementById('s_fluteWidth').value = state.fluteWidth;
//     document.getElementById('s_fluteStrength').value = state.fluteStrength;
//     document.getElementById('s_shading').value = state.shading;
//     document.getElementById('s_glossiness').value = state.glossiness;
//     document.getElementById('s_lightAngle').value = state.lightAngle;
//     document.getElementById('s_gradientScale').value = state.gradientScale;
//     document.getElementById('s_sharpness').value = state.sharpness;
//     document.getElementById('s_intensity').value = state.intensity;
//     document.getElementById('s_exposure').value = state.exposure;
//     document.getElementById('s_warpStrength').value = state.warpStrength;
//     document.getElementById('s_noiseX').value = state.noiseX;
//     document.getElementById('s_noiseY').value = state.noiseY;
//     document.getElementById('s_animSpeed').value = state.animSpeed;
//     document.getElementById('s_grain').value = state.grain;
//     document.getElementById('v_fluteWidth').textContent = state.fluteWidth+'px';
//     document.getElementById('v_fluteStrength').textContent = state.fluteStrength+'px';
//     document.getElementById('v_shading').textContent = state.shading+'%';
//     document.getElementById('v_glossiness').textContent = state.glossiness.toFixed(2);
//     document.getElementById('v_lightAngle').textContent = state.lightAngle.toFixed(2);
//     document.getElementById('v_gradientScale').textContent = state.gradientScale.toFixed(2)+'×';
//     document.getElementById('v_sharpness').textContent = state.sharpness.toFixed(1);
//     document.getElementById('v_intensity').textContent = state.intensity.toFixed(2);
//     document.getElementById('v_exposure').textContent = state.exposure.toFixed(2);
//     document.getElementById('v_warpStrength').textContent = state.warpStrength.toFixed(2);
//     document.getElementById('v_noiseX').textContent = state.noiseX.toFixed(1);
//     document.getElementById('v_noiseY').textContent = state.noiseY.toFixed(1);
//     document.getElementById('v_animSpeed').textContent = state.animSpeed.toFixed(2)+'×';
//     document.getElementById('v_grain').textContent = state.grain.toFixed(3);
//     pausedAt = 1300;
//     document.getElementById('seedInput').value = pausedAt.toFixed(2);
//     playing = wasPlaying;
//   });

//   document.getElementById('mobileToggle').addEventListener('click', ()=>{
//     document.getElementById('sidebar').classList.toggle('open');
//   });

//   document.getElementById('exportBtn').addEventListener('click', doExport);
//   document.getElementById('exportVideoBtn').addEventListener('click', doVideoExport);
// }
// initControls();

// ---------------------------------------------------------------
// Export (offscreen high-res render)
// ---------------------------------------------------------------
// function doExport(){
//   const resSel = document.getElementById('exportRes').value;
//   const format = document.getElementById('exportFormat').value;
//   let w, h;
//   if(resSel === 'current'){
//     w = canvas.width; h = canvas.height;
//   } else {
//     const parts = resSel.split('x');
//     w = parseInt(parts[0],10);
//     h = parseInt(parts[1],10);
//   }

//   // Capture the exact time value currently on screen right now, so the
//   // export is guaranteed to match what you're looking at, frame-for-frame.
//   const exportT = lastT;

//   const overlay = document.getElementById('exportOverlay');
//   overlay.classList.add('show');
//   document.getElementById('exportMsg').textContent = `Rendering ${w}×${h} image…`;
//   exporting = true;

//   // give the browser a chance to paint the overlay before the (blocking) big render
//   setTimeout(()=>{
//     try{
//       const prevW = canvas.width, prevH = canvas.height;
//       canvas.width = w;
//       canvas.height = h;

//       renderNoisePass(exportT);
//       renderMainPass(exportT, w, h);

//       const ext = format === 'image/png' ? 'png' : 'jpg';
//       canvas.toBlob(function(blob){
//         // restore canvas to preview size
//         canvas.width = prevW;
//         canvas.height = prevH;
//         exporting = false;
//         overlay.classList.remove('show');

//         if(!blob){
//           alert('Export failed — the requested resolution may be too large for this browser/GPU. Try a smaller size.');
//           return;
//         }
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = `fractal-glass-gradient-${w}x${h}.${ext}`;
//         document.body.appendChild(a);
//         a.click();
//         document.body.removeChild(a);
//         setTimeout(()=>URL.revokeObjectURL(url), 4000);
//       }, format, format === 'image/jpeg' ? 0.95 : undefined);

//     } catch(err){
//       console.error(err);
//       exporting = false;
//       overlay.classList.remove('show');
//       alert('Export failed: ' + err.message + '\nTry a smaller export resolution.');
//       canvas.width = canvas.clientWidth;
//       canvas.height = canvas.clientHeight;
//     }
//   }, 50);
// }

// ---------------------------------------------------------------
// Video export (real-time canvas capture via MediaRecorder)
// ---------------------------------------------------------------
// function pickVideoMimeType(formatPref){
//   if(typeof MediaRecorder === 'undefined') return null;
//   const mp4Candidates = [
//     'video/mp4;codecs=avc1.640028',
//     'video/mp4;codecs=h264',
//     'video/mp4'
//   ];
//   const webmCandidates = [
//     'video/webm;codecs=vp9',
//     'video/webm;codecs=vp8',
//     'video/webm'
//   ];
//   const tryList = formatPref === 'webm' ? webmCandidates : mp4Candidates.concat(webmCandidates);
//   for(let i=0;i<tryList.length;i++){
//     const type = tryList[i];
//     if(MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(type)){
//       return type;
//     }
//   }
//   return ''; // let the browser choose its own default
// }

// function doVideoExport(){
//   if(typeof MediaRecorder === 'undefined' || !canvas.captureStream){
//     alert('Video export needs the MediaRecorder / captureStream browser APIs, which aren\'t available here. Try a recent version of Chrome, Firefox, or Edge.');
//     return;
//   }

//   const resSel = document.getElementById('videoRes').value;
//   const parts = resSel.split('x');
//   const w = parseInt(parts[0],10);
//   const h = parseInt(parts[1],10);
//   const fps = parseInt(document.getElementById('videoFps').value, 10);
//   const formatPref = document.getElementById('videoFormat').value;
//   const startSec = parseFloat(document.getElementById('videoStart').value);
//   const endSec = parseFloat(document.getElementById('videoEnd').value);

//   if(isNaN(startSec) || isNaN(endSec) || endSec <= startSec){
//     alert('End time must be a number greater than Start time.');
//     return;
//   }
//   const duration = endSec - startSec;
//   if(duration > 90){
//     const ok = confirm(`This records in real time — a ${duration.toFixed(1)}s clip will take about ${Math.round(duration)} seconds to render. Continue?`);
//     if(!ok) return;
//   }

//   const mimeType = pickVideoMimeType(formatPref);
//   if(mimeType === null){
//     alert('Video export is not supported in this browser.');
//     return;
//   }

//   const prevW = canvas.width, prevH = canvas.height;
//   canvas.width = w;
//   canvas.height = h;

//   const overlay = document.getElementById('exportOverlay');
//   const msgEl = document.getElementById('exportMsg');
//   const cancelBtn = document.getElementById('overlayCancelBtn');
//   overlay.classList.add('show');
//   cancelBtn.style.display = 'inline-flex';
//   msgEl.textContent = `Preparing ${w}×${h} video…`;
//   exporting = true;

//   const stream = canvas.captureStream(fps);
//   let recorder;
//   try{
//     const opts = { videoBitsPerSecond: (w >= 3840) ? 45000000 : 14000000 };
//     if(mimeType) opts.mimeType = mimeType;
//     recorder = new MediaRecorder(stream, opts);
//   } catch(err){
//     console.error(err);
//     exporting = false;
//     overlay.classList.remove('show');
//     cancelBtn.style.display = 'none';
//     canvas.width = prevW; canvas.height = prevH;
//     alert('Could not start the video recorder: ' + err.message);
//     return;
//   }

//   const chunks = [];
//   let cancelled = false;

//   recorder.ondataavailable = function(e){
//     if(e.data && e.data.size > 0) chunks.push(e.data);
//   };

//   function cleanup(){
//     exporting = false;
//     overlay.classList.remove('show');
//     cancelBtn.style.display = 'none';
//     cancelBtn.onclick = null;
//     canvas.width = prevW;
//     canvas.height = prevH;
//     stream.getTracks().forEach(function(t){ t.stop(); });
//   }

//   recorder.onstop = function(){
//     if(cancelled){
//       cleanup();
//       return;
//     }
//     const outMime = recorder.mimeType || mimeType || 'video/webm';
//     const isMp4 = outMime.indexOf('mp4') !== -1;
//     const ext = isMp4 ? 'mp4' : 'webm';
//     const blob = new Blob(chunks, { type: outMime });
//     cleanup();

//     if(!blob || blob.size === 0){
//       alert('Recording produced an empty file — please try again, ideally with the tab in the foreground.');
//       return;
//     }

//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `fractal-glass-gradient-${w}x${h}.${ext}`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     setTimeout(function(){ URL.revokeObjectURL(url); }, 4000);

//     if(!isMp4 && formatPref === 'auto'){
//       setTimeout(function(){
//         alert('Your browser doesn\'t support recording directly to MP4, so a WebM file downloaded instead. It plays in all major browsers/players — convert to MP4 with any free tool if you need that exact extension.');
//       }, 150);
//     }
//   };

//   cancelBtn.onclick = function(){
//     cancelled = true;
//     if(recorder.state !== 'inactive') recorder.stop();
//   };

//   recorder.start();

//   const totalFrames = Math.max(1, Math.round(duration * fps));
//   let frameIndex = 0;

//   function renderNextFrame(){
//     if(cancelled) return;
//     if(frameIndex >= totalFrames){
//       if(recorder.state !== 'inactive') recorder.stop();
//       return;
//     }
//     const t = startSec + frameIndex / fps;
//     renderNoisePass(t);
//     renderMainPass(t, w, h);
//     frameIndex++;
//     msgEl.textContent = `Recording frame ${frameIndex} / ${totalFrames} — ${(frameIndex/fps).toFixed(1)}s / ${duration.toFixed(1)}s…`;
//     setTimeout(renderNextFrame, 1000 / fps);
//   }
//   renderNextFrame();
// }

})();